<template>
  <div v-loading="loading" class="val-analisis-container">
    <div class="val-analisis-init-text-container">
      <div class="init-text--1" v-html="$t('init-stock-text-1')" />
      <div class="init-text--2" v-html="$t('init-stock-text-2')" />
    </div>
    <div class="val-analisis-scroll-tabs-container mt-1">
      <scrollTabs v-if="filteredStockSummary.length > 1" scroll-block="nearest">
        <scrollTab v-for="(typo, index) in filteredStockSummary" :key="index" :name="$t(typo.flatTypeLiteral)" :target-id="'stock-table--' + typo.flatType" />
      </scrollTabs>
    </div>
    <div class="val-analisis-tables">
      <div v-for="(table, key) in filteredStockSummary" :id="'stock-table--' + table.flatType" :key="key" class="val-analisis-tables--table mb-5">

        <div class="valuationstock-export">
          <div class="brains-btn-download" @click="downloadGenericTable('valuationstock_' + key)">{{ $t('export') }} <font-awesome-icon icon="download" /></div>
        </div>

        <div class="valuations_subtitle mb-1">
          <span class="subtitle-1">{{ $t('supply-and-demand') }}</span> <span class="subtitle-2">({{ $t(table.flatTypeLiteral) }})</span>
        </div>

        <table :class="'valuationstock_' + key" class="brains-table brains-table--double-horizontal" aria-describedby="tabstockdob">
          <thead>
            <tr v-if="table.stockDataType === 'bed'">
              <th scope="col" />
              <th scope="col" />
              <th scope="col">1 <img :src="bed" class="tableicon" alt="img"></th>
              <th scope="col">2 <img :src="bed" class="tableicon" alt="img"></th>
              <th scope="col">3 <img :src="bed" class="tableicon" alt="img"></th>
              <th scope="col">4 <img :src="bed" class="tableicon" alt="img"></th>
              <th scope="col">{{ $t("average") }}</th>
            </tr>
            <tr v-else-if="table.stockDataType === 'smallSQM'">
              <th scope="col" />
              <th scope="col" />
              <th scope="col">&#60; 100 {{ $t('sqm') }}</th>
              <th scope="col">100 - 250 {{ $t('sqm') }}</th>
              <th scope="col">250 - 500 {{ $t('sqm') }}</th>
              <th scope="col">&#62; 500 {{ $t('sqm') }}</th>
              <th scope="col">{{ $t("average") }}</th>
            </tr>
            <tr v-else>
              <th scope="col" />
              <th scope="col" />
              <th scope="col">&#60; 500 {{ $t('sqm') }}</th>
              <th scope="col">500 - 1.000 {{ $t('sqm') }}</th>
              <th scope="col">1.000 - 2.500 {{ $t('sqm') }}</th>
              <th scope="col">&#62; 2.500 {{ $t('sqm') }}</th>
              <th scope="col">{{ $t("average") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="table && table.published">
              <td class="brains-table-rowspan" rowspan="2">{{ $t('units2') }}</td>
              <td>{{ $t('supply') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "num_habitaciones", table) }}</td>
              </template>
              <td>{{ getDataNumHabitacionAvgTable("published", table) }}</td>
            </tr>
            <tr v-if="table && table.unpublished">
              <td>{{ $t('demand') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "num_habitaciones", table) }}</td>
              </template>
              <td>{{ getDataNumHabitacionAvgTable("unpublished", table) }}</td>
            </tr>
            <!-- ------------------- -->

            <tr v-if="table && table.published">
              <td class="brains-table-rowspan" rowspan="2">%</td>
              <td>{{ $t('supply') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "porcentaje", table) }}%</td>
              </template>
              <td>100%</td>
            </tr>
            <tr v-if="table && table.unpublished">
              <td>{{ $t('demand') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "porcentaje", table) }}%</td>
              </template>
              <td>100%</td>
            </tr>
            <!-- ------------------- -->

            <tr v-if="table && table.published">
              <td class="brains-table-rowspan" rowspan="2">
                <span v-if="currentFilter.sale.c_tipo_contrato === 'Venta'">{{ $t("marketplace.eur-sqm") }}</span>
                <span v-else>{{ $t("assetData.eur-sqm-mo") }}</span>
              </td>
              <td>{{ $t('supply') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "esqm2", table) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_pub", "esqm2", table) }}</td>
            </tr>
            <tr v-if="table && table.unpublished">
              <td>{{ $t('demand') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "esqm2", table) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_unpub", "esqm2", table) }}</td>
            </tr>
            <!-- ------------------ -->

            <tr v-if="table && table.published">
              <td class="brains-table-rowspan" rowspan="2">
                <span v-if="currentFilter.sale.c_tipo_contrato === 'Venta'">€</span>
                <span v-else>{{ $t("assetData.eur-month") }}</span>
              </td>
              <td>{{ $t('supply') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "euro", table) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_pub", "euro", table) }}</td>
            </tr>
            <tr v-if="table && table.unpublished">
              <td>{{ $t('demand') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "euro", table) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_unpub", "euro", table) }}</td>
            </tr>
            <!-- --------------------- -->

            <tr v-if="table && table.published">
              <td class="brains-table-rowspan" rowspan="2">{{ $t("valuationFilters.sqm") }}</td>
              <td>{{ $t('supply') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "sqm", table) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_pub", "sqm", table) }}</td>
            </tr>
            <tr v-if="table && table.unpublished">
              <td>{{ $t('demand') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "sqm", table) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_unpub", "sqm", table) }}</td>
            </tr>

            <!-- ------------------------ -->

            <!-- <tr v-if="table && table.published">
              <td class="brains-table-rowspan" rowspan="2">{{ $t("dataSelectors.published-time") }}</td>
              <td>{{ $t('supply') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "published", "published_time", table) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_pub", "published_time", table) }}</td>
            </tr> -->
            <tr v-if="table && table.unpublished">
              <td class="ff-semibold" rowspan="2">{{ $t("dataSelectors.published-time") }}</td>
              <td rowspan="2">{{ $t('demand') }}</td>
              <template v-for="(n, index) in nhab">
                <td :key="index">{{ getDataHabitacionTable(n, "unpublished", "published_time", table) }}</td>
              </template>
              <td>{{ getDataHabitacionAvgTable("avg_unpub", "published_time", table) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredStockSummary.length === 0" class="val-analisis-tables--nothing">
        {{ $t('there-is-no-sel-typo') }}
      </div>
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'
// import { parseStockComparables } from '@/api/comparable'
import bed from '@/assets/brains_icons/bedon.svg'
import scrollTabs from '@/components/designComponents/scrollTabs'
import scrollTab from '@/components/designComponents/scrollTab'

import exportTable from '@/components/mixins/exportTable'
import { mapState } from 'vuex'
export default {
  name: 'ValuationStock',
  components: { scrollTabs, scrollTab },
  mixins: [exportTable],
  data: () => ({
    nhab: [1, 2, 3, 4],
    bed: bed,
    stocksummary: [],
    stockTableDataExport: null,
    typologiesIdTipoMap: {
      1: 'flat',
      2: 'house',
      3: 'parking',
      4: 'storage',
      5: 'land',
      6: 'retail',
      7: 'office',
      9: 'hospitality',
      10: 'industrial',
      11: 'other'
    },
    loading: false
  }),
  computed: {
    ...mapState('valuations', {
      currentComparables: (state) => state.currentComparables,
      currentFilter: (state) => state.currentFilter
    }),
    filteredStockSummary() {
      if (this.stocksummary !== null && this.stocksummary !== undefined) {
        return this.stocksummary.filter((v, i, a) => a.findIndex((t) => t.flatType === v.flatType) === i)
      } else {
        return []
      }
    }
  },
  watch: {
    currentComparables: function() {
      this.manageStockValuationTables()
    },
    filteredStockSummary: {
      handler(newOne) {
        this.stockTableDataExport = newOne
        this.$store.dispatch('valuations/setStockTable', newOne)
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    manageStockValuationTables() {
      this.stocksummary = []

      this.currentFilter.flat.flat_type.forEach(async(flat) => {
        var data = await this.loadStockValuationTable(flat)
        this.stocksummary.push(data)
      })
    },
    async loadStockValuationTable(flatType) {
      var vm = this
      this.loading = true

      var objStockTable = {
        stockDataType: 'bed',
        flatType: flatType,
        flatTypeLiteral: '',
        avg_pub: [],
        avg_unpub: [],
        published: [],
        unpublished: []
      }

      if (flatType === 'office' || flatType === 'retail') {
        objStockTable.stockDataType = 'smallSQM'
      } else if (flatType === 'industrial' || flatType === 'landplot' || flatType === 'hospitality') {
        objStockTable.stockDataType = 'largeSQM'
      } else {
        objStockTable.stockDataType = 'bed'
      }

      objStockTable.flatTypeLiteral = this.getFlatTypeLiteral(flatType)
      return vm.$store.dispatch('valuations/parseStockComparables', _.filter(this.currentComparables, function(item) { return item.c_ID_tipo === vm.getTypoID(flatType) }))
        .then((response) => {
          if (response === null || response === undefined) {
            return
          }

          objStockTable.avg_pub = response.avg_pub
          objStockTable.avg_unpub = response.avg_unpub
          objStockTable.published = response.published
          objStockTable.unpublished = response.unpublished

          // this.stocksummary.push(objStockTable);
          this.loading = false
          return objStockTable
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
        })
    },
    getFlatTypeLiteral(flat) {
      switch (flat) {
        case 'flat':
          return 'dataSelectors.flat'
        case 'office':
          return 'dataSelectors.office'
        case 'landplot':
          return 'dataSelectors.landplot'
        case 'retail':
          return 'dataSelectors.retail'
        case 'hospitality':
          return 'dataSelectors.hospitality'
        case 'parking':
          return 'parking'
        case 'other':
          return 'other'
        case 'all':
          return 'dataSelectors.all'
        case 'house':
          return 'dataSelectors.house'
        case 'industrial':
          return 'dataSelectors.industrial'
        case 'storage':
          return 'valuationFilters.storage'
        default:
          return flat
      }
    },
    getDataHabitacionTable(n, type, unit, table) {
      var result = _.filter(table[type], function(item) {
        return item.habitaciones === n
      })
      if (result.length > 0) {
        result = result[0][unit]
      } else {
        result = '-'
      }
      if (result === null || result === undefined) {
        result = '-'
      } else {
        if (unit === 'porcentaje' || unit === 'published_time') {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 1 })
        } else if (this.currentFilter.sale.c_tipo_contrato === 'Alquiler' && unit === 'esqm2') {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
        } else {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        }
      }
      return result
    },
    getDataHabitacionAvgTable(type, unit, table) {
      var result = table[type]
      if (result !== null && result !== undefined && result[unit] !== null && result[unit] !== undefined && result[unit] !== 'NaN') {
        result = result[unit]
      } else {
        result = '-'
      }
      if (result === null || result === undefined) {
        result = '-'
      } else {
        if (unit === 'porcentaje' || unit === 'published_time') {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 1 })
        } else if (this.currentFilter.sale.c_tipo_contrato === 'Alquiler' && unit === 'esqm2') {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
        } else {
          result = result.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        }
      }
      return result
    },
    getTypoID(flat) {
      switch (flat) {
        case 'flat': return 1
        case 'house': return 2
        case 'parking': return 3
        case 'storage': return 4
        case 'land': return 5
        case 'retail': return 6
        case 'office': return 7
        case 'hospitality': return 9
        case 'industrial': return 10
        case 'other': return 11
        default: return 0
      }
    },
    getDataNumHabitacionAvgTable(type, table) {
      var result = 0

      if (table !== null && table !== undefined) {
        table[type].forEach(item => {
          if (item.num_habitaciones !== null) {
            result += item.num_habitaciones
          }
        })
      }

      if (result === 0) {
        result = '-'
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.valuationstock-export {
  display: flex;
  align-items: center;
  justify-content: right;
}

.ff-semibold {
  font-family: 'Montserrat-SemiBold',sans-serif;
}

.val-analisis-container {
  position: relative;
  height: 100%;
  font-family: "Montserrat-Regular",sans-serif;

  .val-analisis-init-text-container {
    padding: 45px 25px 10px 25px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    text-align: justify;
    /*line-height: 20px;*/
    font-size: 13px;
    line-height: 1.5;
  }

  .val-analisis-tables {
    padding: 20px;
    height: calc(65vh - 50px);
    overflow: auto;
    font-size: 0.8em;

    &--nothing {
      font-size: 18px;
      text-align: center;
      font-family: "Montserrat-SemiBold",sans-serif;
    }
  }
}

.valuations_subtitle {
  margin-bottom: 3px;
  font-size: 16px;

  .subtitle-1 {
    font-family: 'Montserrat-SemiBold',sans-serif;
  }

  .subtitle-2 {
    font-family: 'Montserrat-Light',sans-serif !important;
  }

  .valuations_subtitle_small {
    font-weight: normal;
    font-family: "Montserrat-Regular",sans-serif;
    font-size: 0.8em;
  }
}
</style>

<style lang="scss">
.val-analisis-scroll-tabs-container {
  height: 36px;

  .brains-scroll-tabs-container {
    .brains-scroll-container {
      .brains-scroll-tabs {
        padding-top: 10px !important;
        padding-bottom: 10px !important;

        .brains-scroll-tabs--tab {
          font-size: 15px;
        }
      }
    }
  }
}
</style>
